import * as React from 'react';
import strings from '../../strings/strings.json';
import Stepper from 'components/stepper/Stepper';
import ChangeUserRoleForm from './components/ChangeUserRoleForm';
import { createEmptyUserRole, createUserRoleFromUserModel, UserRole } from 'models/inputModels/UserRole';
import SelectOrganisationForm from './components/SelectOrganisationForm';
import { MainSectionWithGaps } from '../../components/sections/MainSection';
import { useParams } from 'react-router-dom';
import useGetRequest from '../../hooks/useGetRequest';
import { UserModel } from '../../models/User';
import Notification, { NotificationType } from '../../components/notifiers/Notification';
import Header from 'components/sections/Header';
import NavBackButton from 'components/buttons/NavBackButton';

export default function ChangeUserRolePage(): JSX.Element {
    const params = useParams();
    const { id } = params;

    const { data: user, loading: userLoading, errors: userErrors } = useGetRequest<UserModel>(`users/${id}`);

    const steps = [
        { name: 'User role', Form: ChangeUserRoleForm },
        { name: 'Organisation', Form: SelectOrganisationForm },
    ];

    if (!user && !userLoading && userErrors && userErrors.length > 0) {
        return (
            <>
                <Header
                    title={strings.changeUserRolePage.title}
                    aboveTitleElement={
                        <NavBackButton
                            backButtonTitle={strings.updateOrganisationPage.backButtonTitle}
                            backButtonAria={strings.updateOrganisationPage.backButtonTitleAria}
                            backButtonHref={'/admin/dashboard'}
                        />
                    }
                />
                <Notification
                    notificationType={NotificationType.DANGER}
                    title={strings.changeUserRolePage.errorLoadingUserRoles}
                />
            </>
        );
    }

    return (
        <>
            <Header
                title={strings.changeUserRolePage.title}
                aboveTitleElement={
                    <NavBackButton
                        backButtonTitle={strings.updateOrganisationPage.backButtonTitle}
                        backButtonAria={strings.updateOrganisationPage.backButtonTitleAria}
                        backButtonHref={'/admin/dashboard'}
                    />
                }
            />
            <MainSectionWithGaps>
                <Stepper<UserRole>
                    defaultObject={user ? createUserRoleFromUserModel(user, id ?? '') : createEmptyUserRole(id ?? '')}
                    steps={steps}
                    defaultStep={0}
                    isSmall={true}
                />
            </MainSectionWithGaps>
        </>
    );
}
